/** @format */

import {styled, Theme} from '@mui/material/styles';
import {TableRow} from '@mui/material';

import {TableVariant} from '../../types';

interface HoverOptions {
  variant: TableVariant;
  isClickable: boolean;
  theme: Theme;
}

const getHoverBg = ({variant, theme, isClickable}: HoverOptions): string | undefined => {
  if (isClickable) {
    if (variant === 'light') {
      return theme.palette.figma_gray_light_1?.main;
    }
    return theme.palette.figma_gray_dark_2?.main;
  }

  if (variant === 'light') {
    return theme.palette.semantic_light?.surface.surface1;
  }
  return 'none';
};

interface TableBodyRowProps {
  canExpand: boolean;
  canClick: boolean;
  canSelect: boolean;
  variant: TableVariant;
}

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: prop =>
    prop !== 'canExpand' && prop !== 'canClick' && prop !== 'canSelect' && prop !== 'variant',
})<TableBodyRowProps>(({theme, canExpand, canClick, canSelect, variant}) => {
  const isClickable = canExpand || canClick || canSelect;
  return {
    cursor: isClickable ? 'pointer' : 'default',

    '&:hover': {
      background: getHoverBg({theme, variant, isClickable}),
    },

    // Стили текста по умолчанию для всех Typography
    '.MuiTableCell-root .MuiTypography-root': {
      color:
        variant === 'dark'
          ? theme.palette.figma_gray_light_1?.main
          : theme.palette.figma_gray_dark_5?.main,
      fontWeight: 400,
      fontSize: variant === 'light' ? '14px' : 'inherit',
      lineHeight: variant === 'light' ? '16px' : 'inherit',
    },
  };
});
